module.exports = __webpack_public_path__ + "img/search-icon.b1c37970.svg";